import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-meditabs',
  templateUrl: './meditabs.component.html',
  styleUrls: ['./meditabs.component.scss'],
})
export class MeditabsComponent implements OnInit {
  @Input() section: string;

  homeIcon = 'ico-inicio';
  mediagendaIcon = 'ico-mediagenda';
  billeteraIcon = 'ico-billetera';
  home = false;
  mediagenda = false;
  wallet = false;

  constructor() {}

  ngOnInit() {
    switch (this.section) {
      case 'inicio':
        this.homeIcon = 'ico-inicio-active';
        this.home = true;
        break;
      case 'mediagenda':
        this.mediagendaIcon = 'ico-mediagenda-active';
        this.mediagenda = true;
        break;
      case 'billetera':
        this.billeteraIcon = 'ico-billetera-active';
        this.wallet = true;
        break;
      default:
        break;

    }

  }

}
